import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { TranslateModule } from "@ngx-translate/core";
import { DialogLayoutModule } from "@obg/mat.ui.core";
import { MatGlobalModule } from "@obg/mat.ui.global";
import { CoreContentModule } from "@obg/ngx.core.content";
import { RouterModule } from "@obg/ngx.router";
import { CommonValidationRendererModule } from "@obg/ngx.ui.common";
import { CompactFooterModule, ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { RenewPasswordContainer } from "./renew-password.container";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		DialogLayoutModule,
		TranslateModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatSelectModule,
		CompactFooterModule,
		CoreContentModule,
		CoreUiModule,
		GlobalUiModule,
		MatGlobalModule,
		RouterModule,
		CommonValidationRendererModule,
	],
	exports: [RenewPasswordContainer],
	declarations: [RenewPasswordContainer],
})
export class RenewPasswordModule {
	constructor(resolver: ComponentFactoryResolver, componentFactoryService: ComponentFactoryService) {
		componentFactoryService.registerLazyLoadedResolver(resolver, RenewPasswordContainer);
	}
}
